
export default class Errors {

    constructor(errors = {}) {
        this.errors = errors;
    }

    record(errors) {
        this.errors = errors;
    }

    wipe() {
        this.errors = {};
    }

    create(field, message) {
        if(!this.errors.hasOwnProperty(field)) {
            this.errors[field] = [];
        }
        this.errors[field].push(message);
    }

    has(field) {
        if(field && typeof field === 'string') {
            if (field.match(/\w+\[\w+]/)) {
                // object[field]
                let [object, name] = field.toString().split(/\W/);
                return this.errors.hasOwnProperty(object +'.'+ name);
            } else {
                return this.errors.hasOwnProperty(field);
            }
        }
        return false;
    }

    all() {
        return this.errors;
    }

    get(field) {
        if(field && typeof field === 'string') {
            if (field.match(/\w+\[\w+]/)) {
                // Match array of fields e.g. object[field]
                let [object, name] = field.toString().split(/\W/);
                if(this.errors[object +'.'+ name]) {
                    return this.errors[object +'.'+ name][0];
                }
            }
            else if (this.errors[field]) {
                return this.errors[field][0];
            }
        }
    }

    clear(field) {
        if(field && typeof field === 'string') {
            if(field.match(/\w+\[\w+]/)) {
                // object[field]
                let [object, name] = field.toString().split(/\W/);
                delete this.errors[object +'.'+ name];
            } else {
                delete this.errors[field];
            }
        }
    }
}